export default __webpack_public_path__ + "static/media/22_photo.c8fdd870.jpeg";